import { TpvCompany } from '@app/domain/models/tpv/company-directory.model';
import { CompanyDto } from '@app/data/dtos/tpv/company-directory.dto';

/** DTO de empresa -> entidad de dominio (id = id_company). */
export function mapCompany(dto: CompanyDto): TpvCompany {
  return {
    idCompany: dto.id_company,
    orgIdCompany: dto.org_id_company,
    name: dto.name ?? '',
    legalName: dto.social_name ?? '',
    rfc: dto.rfc,
    representative: dto.represent,
    commercialAgent: dto.agente_comercial,
    status: dto.status ?? '',
    entity: dto.entity,
    totalUnits: dto.total_units,
  };
}
